import { gql } from '@apollo/client';

export const createCategoryMutation = gql`
  mutation createCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
    }
  }
`;
